import React, { useState, useEffect, useRef } from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda, colores, cmes, round } from "../util/varios";
import { Mensaje } from "../components/mensajes";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { useBcv } from "../hooks/useBcv";

function Inicio() {
  const token = sessionStorage.getItem("jwtToken");
  const op = require("../../public/modulos/datos");
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
  const accinicio = JSON.parse(sessionStorage.getItem("accinicioc"));

  const headCells = [
    { label: "FECHA", textAlign: "center" },
    { label: "FACTURA N°", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
    { label: "STATUS", textAlign: "center" },
  ];

  const txtLogo = useRef();
  const txtMoneda = useRef();
  const cmbMesEst = useRef();
  const txtAnio = useRef();
  const [activate, setActivate] = useState(false);
  const [labelMoneda, setLabelMoneda] = useState([]);
  const [labelVentas, setLabelVentas] = useState([]);
  const [valorVentas, setValorVentas] = useState([]);
  const [valorCobrado, setValorCobrado] = useState([]);
  const [valorPorCobrado, setValorPorCobrado] = useState([]);
  const [valor, setValor] = useState([]);
  const [bloqueado, setBloqueado] = useState(true);
  const [idm, setIdm] = useState({
    idmoneda: "",
    descripcion: "",
    simbolo: "",
    predeterminada: "",
    valormoneda: "",
    subpredeterminada: true,
  });
  const [total, setTotal] = useState(0.0);
  const [tipo, setTipo] = useState([]);
  const [datos, setDatos] = useState([]);
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  useBcv();

  const [totalVentas, setTotalVentas] = useState(0.0);
  const [totalCobrado, setTotalCobrado] = useState(0.0);
  const [totalAbAn, setTotalAbAn] = useState(0.0);
  const [totalPorCobrar, setTotalPorCobrar] = useState(0.0);

  const [colorG, setColorG] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              moment(x.fecha)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.numfactura.toLowerCase().includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.totalmonto.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              (x.status === 0 ? "Por Cobrar" : "Cobrada")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarFacturas = () => {
    let endpoint = `${op.conexion}/api/registropago/seleccionarfacturas?&status=5&anio=${txtAnio.current.value}&mes=${cmbMesEst.current.value}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            let vnt = 0.0;
            let cbd = 0.0;
            let pcb = 0.0;
            let abono = 0.0;
            let anticipos = 0.0;
            let totalxcobrar = 0.0;
            let totalpagados = 0.0;
            let clientArray = [];

            for (let i = 0; i < response.data.length; i++) {
              vnt = parseFloat(response.data[i].totalmonto) > 0 ? parseFloat(vnt) + parseFloat(response.data[i].totalmonto) : parseFloat(vnt);
              abono = abono + parseFloat(response.data[i].abono);

              if (response.data[i].status === 1) {
                cbd = cbd + parseFloat(response.data[i].totalmonto);
              }

              if (response.data[i].status === 0 && parseFloat(response.data[i].totalmonto) > 0) {
                pcb = pcb + parseFloat(response.data[i].totalmonto);
              }

            }

            for (let e = 0; e < response.data.length; e++) {

              if (!clientArray.includes(response.data[e].idaganticipo)) {
                clientArray.push(response.data[e].idaganticipo);
                anticipos = anticipos + parseFloat(response.data[e].anticipo);
              }

            }

            totalxcobrar = round(pcb, 2);
            totalpagados = round(cbd, 2);

            setTotalVentas(vnt);
            setTotalCobrado(totalpagados);
            setTotalPorCobrar(totalxcobrar);
            setTotalAbAn(anticipos + abono);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };


  const seleccionarFacturasAnual = () => {
    let campos = `deudas.mes,
    sum(deudas.totalpagado) as pagado,
    sum(deudas.totalventa) as venta,
    sum(deudas.porpagar) as pagar`;
    let nomtab = `(
      select sum(totalmonto) as totalventa,  sum(iif(status = 0, totalmonto, 0.00)) as porpagar,  sum(iif(status = 1, totalmonto, 0.00)) as totalpagado, TO_CHAR(fecha,'MM') as mes 
              from notaentrega where status !=4 and tipo!='NO' and tipo!='NC' and idfactura isnull and  TO_CHAR(fecha,'YYYY') = ${txtAnio.current.value}::text group by mes) deudas group by mes`;
    let orden = "mes asc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let lb = [];
          let dt = [];
          let cb = [];
          let vpc = [];

          if (response.data.length > 0) {
            console.log('si pase', response.data);
            for (let i = 0; i < response.data.length; i++) {
              dt.push(response.data[i].venta);
              cb.push(response.data[i].pagado);
              vpc.push(response.data[i].pagar);
              lb.push(cmes(parseInt(response.data[i].mes)));
            }
          }
          console.log('si pase', dt, cb, vpc, lb);
          setLabelVentas(lb);
          setValorVentas(dt);
          setValorCobrado(cb);
          setValorPorCobrado(vpc);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChange = (e) => {
    if (e.target.name === "mesEst") {
      setTotalVentas(0.0);
      setTotalCobrado(0.0);
      setTotalPorCobrar(0.0);
      setRecords([]);
      seleccionarFacturas();
    }

    if (e.target.name === "anio") {
      setTotalVentas(0.0);
      setTotalCobrado(0.0);
      setTotalPorCobrar(0.0);
      setRecords([]);
      seleccionarFacturas();
      seleccionarFacturasAnual();
    }

    if (e.target.name === "mes") {
      seleccionarMesMoneda(
        e.target.value,
        txtLogo.current.value,
        moment(fechaSistema).format("YYYY")
      );
      setValor([]);
      setLabelMoneda([]);
      setTotal(0.0);
    }

    if (e.target.name === "logo") {
      let val = e.target.value;
      setIdm(tipo[e.target.options.selectedIndex]);
      txtMoneda.current.value = "";
      setValor([]);
      setLabelMoneda([]);

      if (val > 0) {
        setBloqueado(false);
        txtMoneda.current.focus();
      } else {
        setBloqueado(true);
      }
    }
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "moneda";
    let orden = "idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const element = [];
          const color = [];
          const monedasub = {
            idmoneda: "",
            descripcion: "",
            simbolo: "",
            predeterminada: "",
            valormoneda: "",
            subpredeterminada: true,
          };

          if (response.data.length > 0) {
            setTipo(response.data);

            for (let i = 0; i < response.data.length; i++) {
              color.push(colores[i]);
              element.push({
                nombre: response.data[i].descripcion,
                valor: formatMoneda(
                  response.data[i].valormoneda
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                ),
                color: colores[i],
              });
              if (response.data[i].subpredeterminada) {
                monedasub = response.data[i];
              }
            }

            setColorG(color);
            setDatos(element);
            setIdm(monedasub);
            txtLogo.current.value = monedasub.idmoneda;
            txtMoneda.current.value = moment(fechaSistema).format("MM");
            setBloqueado(false);
            seleccionarMesMoneda(
              moment(fechaSistema).format("MM"),
              monedasub.idmoneda,
              moment(fechaSistema).format("YYYY")
            );
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarMesMoneda = (m, id, a) => {
    let endpoint = `${op.conexion
      }/api/moneda/seleccionarmoneda?m=${m.toString()}&id=${id}&a=${a.toString()}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            let to = 0;
            let te = 0;
            let contar = 0;
            var label = [];
            var datos = [];

            for (var i = 0; i < response.data.length; i++) {
              contar = contar + 1;
              label.push(moment(response.data[i].fecha).format("DD-MM"));
              datos.push(response.data[i].valor);
            }

            if (contar > 1) {
              to = contar - 2;
              te = contar - 1;
            }

            setValor(datos);
            setLabelMoneda(label);

            let porcp = 0.0;
            let totalpcp = 0.0;
            let totalreal = 0.0;

            if (datos[to] > datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setTotal(totalpcp);
            } else if (datos[to] < datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setTotal(totalpcp);
            }
          } else {
            setValor([]);
            setLabelMoneda([]);
            setTotal(0.0);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const options = {
    responsive: false,
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Ventas Anuales",
    },
  };

  const data = {
    labels: labelVentas,
    datasets: [
      {
        label: "Ventas",
        data: valorVentas,
        borderColor: "#28a745",
        backgroundColor: "#28a745",
      },
      {
        label: "Cobrado",
        data: valorCobrado,
        borderColor: "#ffc107",
        backgroundColor: "#ffc107",
      },
      {
        label: "Por Cobrar",
        data: valorPorCobrado,
        borderColor: "#dc3545",
        backgroundColor: "#dc3545",
      },
    ],
  };

  const dataTorta = {
    labels: ["Cobrado", "Abonos/Anticipos", "Por Cobrar"],
    leyend: true,
    datasets: [
      {
        label: "#",
        data: [totalCobrado.toFixed(2), totalAbAn.toFixed(2), (totalPorCobrar - totalAbAn).toFixed(2)],
        backgroundColor: ["#ffc107", "#17a2b8", "#dc3545"],
        borderColor: ["#ffc107", "#17a2b8", "#dc3545"],
        borderWidth: 1,
        hoverBorderWidth: 15,
      },
    ],
  };

  const optionsTorta = {
    responsive: false,
    legend: {
      position: "top",
      display: true,
    },
    title: {
      display: true,
      text: `Total en Ventas: ${formatMoneda(
        totalVentas.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      )}`,
    },
  };

  const optionsMoneda = {
    responsive: false,
    title: {
      display: true,
      text: "Variación de la Moneda",
    },
    legend: {
      position: "top",
      display: true,
    },
  };

  const dataMoneda = {
    labels: labelMoneda,
    datasets: [
      {
        label: idm.descripcion + " " + idm.simbolo,
        data: valor,
        borderColor: "rgba(0, 98, 204)",
      },
    ],
  };

  useEffect(() => {
    if (accinicio && accinicio.substring(0, 1) === "1") {
      seleccionarRegistros();
      seleccionarFacturas();
      seleccionarFacturasAnual();
    } else {
      seleccionarRegistros();
    }
  }, []);

  return (
    <div className="col-md-12 d-flex justify-content-center container-fluid p-2 m-0 h-100">
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      {accinicio && accinicio.substring(0, 1) === "1" ? <div className="row h-100 col-md-12 p-0 m-0">
        <div className="row col-md-6 mx-auto h-100">
          <div
            className="card p-0 mb-1 col-md-12 h-50 justify-content-center"
            style={{ display: "grid" }}
          >
            {/*  <Line options={options} height={300} width={500} data={data} /> */}
            <Bar options={options} height={300} width={500} data={data} />
          </div>
          <div className="card col-md-12 h-50 p-0">
            <div className="card-body row p-0">
              <div className="p-0 m-0">
                <div className="card-body row m-0 p-0">
                  <div className="col-md-4 ml-auto">
                    <div className="col-md-10 ml-auto mt-3">
                      <select
                        ref={txtLogo}
                        name="logo"
                        onChange={onChange}
                        className="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                      >
                        {tipo &&
                          tipo.map((item, index) => (
                            <option key={index} value={item.idmoneda}>
                              {item.simbolo}
                              {"."}
                              {item.descripcion}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 ml-auto">
                    <div className="col-md-10 text-center ml-auto mt-3">
                      <div className="d-flex justify-content-center">
                        <span>
                          {total.toString().includes("-") ? (
                            <i className="fas fa-arrow-down text-danger me-2" />
                          ) : (
                            <i className="fas fa-arrow-up text-success me-2" />
                          )}
                        </span>
                        <span
                          style={{
                            color: total.toString().includes("-")
                              ? "#F93154"
                              : "#00B74A",
                          }}
                          className="fw-bold"
                        >
                          {total}
                        </span>
                        <span>
                          {total.toString().includes("-") ? (
                            <i className="fas fa-percent text-danger" />
                          ) : (
                            <i className="fas fa-percent text-success" />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 ml-auto">
                    <div className="col-md-7 ml-auto mt-3">
                      <select
                        className="form-select form-select-sm text-uppercase"
                        disabled={bloqueado}
                        ref={txtMoneda}
                        defaultValue={moment(fechaSistema).format("MM")}
                        name="mes"
                        aria-label=".form-select-sm example"
                        onChange={onChange}
                      >
                        <option value="">Mes</option>
                        <option value={"01"}>Enero</option>
                        <option value={"02"}>Febrero</option>
                        <option value={"03"}>Marzo</option>
                        <option value={"04"}>Abril</option>
                        <option value={"05"}>Mayo</option>
                        <option value={"06"}>Junio</option>
                        <option value={"07"}>Julio</option>
                        <option value={"08"}>Agosto</option>
                        <option value={"09"}>Septiembre</option>
                        <option value={"10"}>Octubre</option>
                        <option value={"11"}>Noviembre</option>
                        <option value={"12"}>Diciembre</option>
                      </select>
                    </div>
                  </div>
                  <div
                    className="col-md-12 justify-content-center"
                    style={{ display: "grid" }}
                  >
                    <Line
                      options={optionsMoneda}
                      height={300}
                      width={500}
                      data={dataMoneda}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row col-md-6 mx-auto h-100">
          <div className="row col-md-12 card h-100">
            <div className="col-md-12 row mx-auto py-3 justify-content-end">
              <div className=" col-md-6 bg-light border-azul row h-50 justify-content-center rounded mx-auto px-0">
                <div className="col-md-12 py-2 " style={{ height: "40%" }}>
                  <div className="row col-md-12 bg-primary text-center rounded p-2 shadow h-100 mx-auto">
                    <label className="text- mt-3 col-12">
                      Datos Estadisticos
                    </label>
                    <select
                      className="form-select form-select-sm rounded mx-auto col-md-6 text-center fw-bold text-uppercase"
                      name="mesEst"
                      ref={cmbMesEst}
                      aria-label=".form-select-sm example"
                      onChange={onChange}
                    >
                      <option value={"anual"}> - Anual - </option>
                      <option value={"01"}> - Enero - </option>
                      <option value={"02"}> - Febrero - </option>
                      <option value={"03"}> - Marzo - </option>
                      <option value={"04"}> - Abril - </option>
                      <option value={"05"}> - Mayo - </option>
                      <option value={"06"}> - Junio - </option>
                      <option value={"07"}> - Julio - </option>
                      <option value={"08"}> - Agosto - </option>
                      <option value={"09"}> - Septiembre - </option>
                      <option value={"10"}> - Octubre - </option>
                      <option value={"11"}> - Noviembre - </option>
                      <option value={"12"}> - Diciembre - </option>
                    </select>
                    <select
                      className="col-md-5 form-select form-select-sm text-center fw-bold  text-uppercase"
                      ref={txtAnio}
                      defaultValue={anioActu}
                      name="anio"
                      onChange={onChange}
                      aria-label=".form-select-sm example"
                    >
                      <option value={anioActu}>{anioActu}</option>
                      <option value={anioActu - 1}>{anioActu - 1}</option>
                      <option value={anioActu - 2}>{anioActu - 2}</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-12 h-100 mb-2">
                  <div className="col-md-12 bg-success mt-2 py-2 mx-auto rounded shadow d-flex align-items-center">
                    <div className="input-group input-group-sm justify-content-between">
                      <span
                        className="input-group-text border-0 bg-transparent fw-bold text-light fs-6"
                        id="inputGroup-sizing-sm"
                      >
                        Total en Ventas:
                      </span>
                      <input
                        type="text"
                        className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light"
                        style={{ fontSize: "0.9rem" }}
                        value={formatMoneda(
                          totalVentas
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        disabled
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 bg-warning mt-2 py-2 mx-auto rounded shadow d-flex align-items-center">
                    <div className="input-group input-group-sm justify-content-between">
                      <span
                        className="input-group-text border-0 bg-transparent fw-bold fs-6"
                        id="inputGroup-sizing-sm"
                      >
                        Total Cobrado:
                      </span>
                      <input
                        type="text"
                        className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right"
                        style={{ fontSize: "0.9rem" }}
                        value={formatMoneda(
                          totalCobrado
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        disabled
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 bg-info mt-2 py-2 mx-auto rounded shadow d-flex align-items-center">
                    <div className="input-group input-group-sm justify-content-between">
                      <span
                        className="input-group-text border-0 bg-transparent fw-bold fs-6"
                        id="inputGroup-sizing-sm"
                      >
                        Total Abonos/Anticipos:
                      </span>
                      <input
                        type="text"
                        className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right"
                        style={{ fontSize: "0.9rem" }}
                        value={formatMoneda(
                          totalAbAn
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        disabled
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 bg-danger mt-2 py-2 mx-auto rounded shadow d-flex align-items-center">
                    <div className="input-group input-group-sm justify-content-between">
                      <span
                        className="input-group-text border-0 bg-transparent fw-bold text-light fs-6"
                        id="inputGroup-sizing-sm"
                      >
                        Total por Cobrar:
                      </span>
                      <input
                        type="text"
                        className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light"
                        style={{ fontSize: "0.9rem" }}
                        value={formatMoneda(
                          (totalPorCobrar - totalAbAn)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        disabled
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 h-50 mx-auto justify-content-center"
                style={{ display: "grid" }}
              >
                <Pie
                  options={optionsTorta}
                  height={300}
                  width={300}
                  data={dataTorta}
                />
              </div>
              <div className="row col-md-12 mt-5">
                <div className="input-group col-md-3 input-group-sm">
                  <input
                    type="text"
                    onChange={handleSearch}
                    placeholder="Buscar"
                    title="Buscar Factura"
                    className="form-control"
                  />
                  <button
                    className="btn"
                    style={{
                      pointerEvents: "none",
                      backgroundColor: "rgba(5, 81, 130, 1)",
                      color: "#FFFFFF",
                    }}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <div className="col-md-12 h-50 mt-3 px-0 mx-0 rounded">
                <TblContainer
                  container={{
                    height: 310,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden table-bordered">
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <TableRow
                          key={index}
                          style={{ padding: "0", fontSizeAdjust: "0.6" }}
                        >
                          <TableCell
                            className="align-baseline bg-light"
                            style={{ textAlign: "center", width: "180px" }}
                          >
                            {moment(item.fecha).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light"
                            style={{ textAlign: "center", width: "180px" }}
                          >
                            {item.numfactura}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light"
                            style={{ textAlign: "center", width: "180px" }}
                          >
                            {formatMoneda(
                              (item.totalmonto - item.abono)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light"
                            style={{ textAlign: "center", width: "180px" }}
                          >
                            {item.status === 0 ? (
                              <span className="text-danger fw-bold">
                                Por Cobrar
                              </span>
                            ) : (
                              <span className="text-success fw-bold">
                                Cobrada
                              </span>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div> : <div className="row h-100 col-md-12 p-0 m-0">
        <div className="card col-md-12 h-50 p-0">
          <div className="card-body row p-0">
            <div className="p-0 m-0">
              <div className="card-body row m-0 p-0">
                <div className="col-md-2">
                  <div className="col-md-10 ml-auto mt-3">
                    <select
                      ref={txtLogo}
                      name="logo"
                      onChange={onChange}
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                    >
                      {tipo &&
                        tipo.map((item, index) => (
                          <option key={index} value={item.idmoneda}>
                            {item.simbolo}
                            {"."}
                            {item.descripcion}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 mx-auto">
                  <div className="col-md-10 text-center ml-auto mt-3">
                    <div className="d-flex justify-content-center">
                      <span>
                        {total.toString().includes("-") ? (
                          <i className="fas fa-arrow-down text-danger me-2" />
                        ) : (
                          <i className="fas fa-arrow-up text-success me-2" />
                        )}
                      </span>
                      <span
                        style={{
                          color: total.toString().includes("-")
                            ? "#F93154"
                            : "#00B74A",
                        }}
                        className="fw-bold"
                      >
                        {total}
                      </span>
                      <span>
                        {total.toString().includes("-") ? (
                          <i className="fas fa-percent text-danger" />
                        ) : (
                          <i className="fas fa-percent text-success" />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-2 ml-auto">
                  <div className="col-md-7 ml-auto mt-3">
                    <select
                      className="form-select form-select-sm text-uppercase"
                      disabled={bloqueado}
                      ref={txtMoneda}
                      defaultValue={moment(fechaSistema).format("MM")}
                      name="mes"
                      aria-label=".form-select-sm example"
                      onChange={onChange}
                    >
                      <option value="">Mes</option>
                      <option value={"01"}>Enero</option>
                      <option value={"02"}>Febrero</option>
                      <option value={"03"}>Marzo</option>
                      <option value={"04"}>Abril</option>
                      <option value={"05"}>Mayo</option>
                      <option value={"06"}>Junio</option>
                      <option value={"07"}>Julio</option>
                      <option value={"08"}>Agosto</option>
                      <option value={"09"}>Septiembre</option>
                      <option value={"10"}>Octubre</option>
                      <option value={"11"}>Noviembre</option>
                      <option value={"12"}>Diciembre</option>
                    </select>
                  </div>
                </div>
                <div
                  className="col-md-12 justify-content-center"
                  style={{ display: "grid" }}
                >
                  <Line
                    options={optionsMoneda}
                    height={600}
                    width={900}
                    data={dataMoneda}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

    </div>
  );
}

export default Inicio;



// WEBPACK FOOTER //
// ./src/pages/inicio.js